import { ReactNode } from 'react';
import Header from './Header';

interface LayoutProps {
  children: ReactNode;
}

const Layout = ({ children }: LayoutProps) => {
  return (
    <>
      <Header />
      <main className="pb-20 lg:pb-0">
        {children}
      </main>
    </>
  );
};

export default Layout;
